import { hasUserPermission } from '~/shared/lib/permissions'
import type { UserProfile } from '~/shared/api/services/users/types'

export const ORDER_STATUS_COUNTS_UPDATED_EVENT = 'order.status_counts.updated'
export const SHIPPING_ORDERS_UPDATED_EVENT = 'shipping.orders.updated'

export const getBaseLayoutBackgroundAccess = (
  profile: UserProfile | null | undefined,
) => ({
  canGetOrderList: hasUserPermission(profile, 'get order list'),
  canGetShippingList: hasUserPermission(profile, 'get shipping list'),
  canGetStoreList: hasUserPermission(profile, 'get store list'),
})

export const canHandleBaseLayoutRealtimeEvent = (
  eventName: string | undefined,
  profile: UserProfile | null | undefined,
) => {
  const access = getBaseLayoutBackgroundAccess(profile)

  if (eventName === ORDER_STATUS_COUNTS_UPDATED_EVENT) {
    return access.canGetOrderList
  }

  if (eventName === SHIPPING_ORDERS_UPDATED_EVENT) {
    return access.canGetShippingList
  }

  return true
}
